var _circle, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m510.497 283.826-.006-.008-.001.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.49 283.826c0-.002.001-.004.001-.008l-280.745-282.487c-12.665 1.291-25.058 3.505-37.109 6.574-110.739 28.195-192.637 248.095-192.637 248.095s358.398 239.835 399.285 212.164c8.181-5.536 16.025-11.533 23.493-17.953l-166.383-166.385z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m445.217 256-248.972-248.971c-112.557 26.917-196.245 128.163-196.245 248.971 0 141.384 114.616 256 256 256 53.629 0 103.397-16.502 144.529-44.689l-211.312-211.311z",
    fill: "#d80027"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.472 377.993-31.265-14.706 16.649-30.279-33.95 6.495-4.302-34.298-23.647 25.225-23.647-25.225-4.303 34.298-33.949-6.496 16.649 30.28-31.266 14.706 31.266 14.705-16.649 30.28 33.951-6.494 4.3 34.296 23.648-25.225 23.647 25.225 4.302-34.296 33.949 6.495-16.649-30.279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.609 141.983-22.74-10.695 12.109-22.023-24.693 4.724-3.129-24.946-17.199 18.347-17.199-18.347-3.13 24.946-24.693-4.724 12.11 22.023-22.741 10.695 55.653 11.132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.739 141.983c0 36.883-29.9 66.783-66.783 66.783s-66.783-29.9-66.783-66.783"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/nepal.38dc86639d26a295bee1f06a78168749.svg";
export { ForwardRef as ReactComponent };